import {
    addToasterToStore,
    removeToasterFromStore,
    addSnackbarToStore,
    removeSnackbarFromStore,
    addConfirmationDialogToStore,
} from 'modules/shared/stores/toasters-slice-handler';

/**
 * Remove a toaster.
 * @param {ToasterOptions} toasterOptions
 */
export function removeToaster(toasterOptions) {
    removeToasterFromStore(toasterOptions);
}

/**
 * Show a toaster.
 * @param {ToasterOptions} toasterOptions
 */
export function addToaster(toasterOptions) {
    addToasterToStore(toasterOptions);
}

/**
 * Remove a snackbar.
 * @param {SnackbarOptions} snackbarOptions
 */
export function removeSnackbar(snackbarOptions) {
    removeSnackbarFromStore(snackbarOptions);
}

/**
 * Show a snackbar.
 * @param {SnackbarOptions} snackbarOptions
 */
export function addSnackbar(snackbarOptions) {
    addSnackbarToStore(snackbarOptions);
}

/**
 * Show a standalone confirmation dialog.
 * @param {ConfirmationDialogOptions} confirmationDialogOptions
 */
export function addConfirmationDialog(confirmationDialogOptions) {
    addConfirmationDialogToStore(confirmationDialogOptions);
}
